import { PhoneIcon } from "lucide-react";
import { MapPinIcon } from "lucide-react";
import { ClockIcon } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      id="contact"
      className="relative w-full pt-12 md:pt-24 lg:pt-32 border-t bg-gray-100 flex items-center justify-center w-full flex-col"
    >
      <div className="px-4 md:px-6 w-full flex justify-center">
        <div className="flex max-w-[1400px] max-lg:max-w-[500px] lg:w-full justify-center flex-wrap gap-5 border">
          <div className="space-y-4 lg:basis-1/2">
            <h3 className="text-2xl font-extrabold font-Lato">Contactanos</h3>
            <p className="text-subtle font-Roboto">
              Nos encantaría saber de ti. Contáctanos para reservas o consultas.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <PhoneIcon className="min-w-4 min-h-4 w-4 h-4 text-mariposa" />
                <span className="text-md font-Roboto">+53 48728030</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPinIcon className="min-w-4 min-h-4 w-4 h-4 text-mariposa" />
                <span className="text-md font-Roboto">
                  Pinar del Rio, Cuba. Calle San Juan, entre Marti y Maximo
                  Gomez
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <ClockIcon className="min-w-4 min-h-4 w-4 h-4 text-mariposa" />
                <span className="text-md font-Roboto">Lunes a Sabado</span>
              </div>
            </div>
          </div>
          <div className="space-y-4"></div>

          <div className="max-lg:w-full  flex justify-center  min-h-[250px] ">
            <iframe
              title="Direccion"
              src="https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d9928.60833683637!2d-83.69640677804372!3d22.411588108105157!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d22.416700788514337!2d-83.69821177105572!5e0!3m2!1ses-419!2sus!4v1733874514862!5m2!1ses-419!2sus"
              className="w-full"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="mt-8 border-t pt-8 text-center text-gray-500">
        © 2024 Overflow Solutions. Todos los derechos reservados.
      </div>
    </footer>
  );
};
